module.exports = __webpack_public_path__ + "static/media/locked.93f02a83.svg";